import { WorkflowParameterMap } from './workflow-parameter-map';
import { SystemTask } from './systemTask.model';

export interface WorkflowStep {
  workflowStepId: string;
  nextStepId?: string;
  prevStepId?: string;
  failedStepId?: string;

  parameterMaps?: WorkflowParameterMap[];
  inputs?: string[];
  outputs?: string[];

  workflowVersionId: string;
  systemTaskId?: string;
  systemTask: SystemTask;
  description: string;
  preferSameUser?: boolean;
  assignToUserGroupId?: string;
}
